<template>
  <div>
    <!-- 面包屑导航 -->
<!--    <el-breadcrumb separator-class="el-icon-arrow-right">-->
<!--      <el-breadcrumb-item :to="{ path: '/Welcome' }">首页</el-breadcrumb-item>-->
<!--      <el-breadcrumb-item>运输公司管理列表</el-breadcrumb-item>-->
<!--    </el-breadcrumb>-->
    <!-- 卡片 -->
    <el-card class="box-card">
      <!-- 搜索  新增-->
      <el-form
          :inline="true"
          :model="searchForm"
          ref="searchForRef"
          autocomplete="on">
        <el-row :gutter="24">
          <el-col :span="5">
            <el-form-item label="投保人名称" size="small" label-width="90px">
              <el-input v-model="searchForm.queryParams" placeholder="请输入投保人名称" clearable type="text"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="开始时间" size="small" label-width="70px">
              <el-date-picker v-model="searchForm.start_time" type="date"  placeholder="请选择开始时间"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="结束时间" size="small" label-width="70px">
              <el-date-picker v-model="searchForm.end_time" type="date"  placeholder="请选择结束时间"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="1">
            <el-button size="small" type="success" @click="searchSubmit()">搜索</el-button>
            <!-- <el-button @click="searchRest()">重置</el-button> -->
          </el-col>
          <el-col :span="1">
            <el-button size="small" type="primary" @click="addData">新增</el-button>
          </el-col>
        </el-row>

      </el-form>

        <!-- 表格 -->
        <el-table
            ref="multipleTable"
            :data="tableLoadData"
            stripe
            border
            height="450"
            size="mini"
            :header-cell-style="{background:'#e5e5e5',color:'#333333'}"
        >

            <el-table-column
              label="公司名称"
              width="110px"
              prop="name"
              :show-overflow-tooltip='true'

            >
            </el-table-column>
          <el-table-column
              label="社会信用代码"
              width="150px"
              prop="credit_code"
              :show-overflow-tooltip='true'

          >
          </el-table-column>
            <el-table-column
              label="法人"
              prop="corporation"
              :show-overflow-tooltip='true'>
            </el-table-column>
            <el-table-column
              label="法人身份证号"
              prop="cardno"
              :show-overflow-tooltip='true'>
            </el-table-column>


            <el-table-column
              label="类型"
              prop="type"
              :show-overflow-tooltip='true'
            >
            </el-table-column>
          <!--
            <el-table-column
              label="经营范围"
              width="80px"
              prop="business_scope"
              :show-overflow-tooltip='true'
            >
            </el-table-column>-->
            <el-table-column
              label="成立日期"
              prop="incorporation_date"
              :show-overflow-tooltip='true'
            >
            </el-table-column>
            <el-table-column
              label="注册资本"
              prop="registered_capital"
              :show-overflow-tooltip='true'
            >
            </el-table-column>

            <el-table-column
              label="地址"
              prop="address"
              :show-overflow-tooltip='true'
            >
            </el-table-column>
            <el-table-column
              label="手机号"
              prop="mobile"
              :show-overflow-tooltip='true'>
            </el-table-column>
            <el-table-column  label="开户行" width="120px"  prop="bank"  :show-overflow-tooltip='true'>

            </el-table-column>
            <el-table-column  label="创建日期" width="120px"  :show-overflow-tooltip='true'>
              <template slot-scope="scope">
                <div>{{scope.row.add_time | dateFormat}}</div>
              </template>

            </el-table-column>
          <el-table-column label="操作" width="290" >
              <template slot-scope="scope">

                <el-tooltip content="查看该公司账户信息">
                <el-button type="primary" size="small" icon="el-icon-share" @click.native="payInfo(scope.row)"></el-button>
                </el-tooltip>
                <el-button type="warning" size="small" icon="el-icon-edit" @click="handelEdit(scope.row)"></el-button>
                <el-button type="danger" size="small" icon="el-icon-delete" @click="handelDel(scope.row)"></el-button>
<!--                <el-button type="primary" size="mini"  @click="checkInfo(scope.row)">查询E宝信息</el-button>-->
                <el-button type="primary" size="mini" plain @click="handelDialog(scope.row)">查看图片</el-button>
              </template>
            </el-table-column>
        </el-table>
        <!-- 分页 -->
        <div class="block" style="margin-top:10px">
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="page"
                :page-sizes="[10, 20, 30, 100]"
                :page-size="limit"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total">
          </el-pagination>
        </div>
    </el-card>
    <!-- 新增编辑弹框 -->
    <el-dialog
            :title="title"
            :visible.sync="dialogFormVisible"
            width="996px"
            style="overflow: auto;height: auto"
    >
      <el-form :model="form" :rules="rules" ref="form" label-width="110px">
          <el-row :gutter="24">
              <el-col :span="12">
                <el-form-item label="公司名称" prop="name" size="small">
                  <el-input v-model="form.name" autocomplete="off" ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="法人" prop="corporation" size="small">
                  <el-input v-model="form.corporation" autocomplete="off" ></el-input>
                </el-form-item>
              </el-col>
          </el-row>
          
          <el-row :gutter="24">
              <el-col :span="12">
                <el-form-item label="营业执照图片" size="small">
                <el-upload class="uploader" :auto-upload="false" :show-file-list="false" drag :on-change="UploadImage" action="#">
                  <i class="el-icon-upload" v-if="!form.file_url">
              <span class="fontStyle1">将营业执照图片拖到此处，或
                <span class="fontStyle2">点击上传</span>
              </span>
                  </i>
                  <div class="uploaded" v-else :style="{'background-image': 'url(' + form.file_url + ')','width':'360px','height':'180px','background-size':'cover','margin-bottom':'200px'}">
<span class="fontStyle3">
                <i class="el-icon-zoom-in" @click="openWin('../../static/typeImg.html?typeImage=' +form.file_url)">查看图片</i>
              <i class="el-icon-delete-solid" @click.stop="delImg(1)">删除图片</i>
              <i class="el-icon-refresh-right" slot="trigger">重新上传</i>
</span>

                  </div>

                </el-upload>
            </el-form-item>

              </el-col>
              <el-col :span="12">
                <el-form-item label="法人身份证图片" size="small">
                  <el-upload class="uploader" :auto-upload="false" :show-file-list="false" drag :on-change="UploadImage2" action="#">
                    <i class="el-icon-upload" v-if="!form.cardno_url">
              <span class="fontStyle1">将法人身份证图片拖到此处，或
                <span class="fontStyle2">点击上传</span>
              </span>
                    </i>
                    <div class="uploaded" v-else :style="{'background-image': 'url(' + form.cardno_url + ')','width':'360px','height':'180px','background-size':'cover','margin-bottom':'200px'}">
<span class="fontStyle3">
                <i class="el-icon-zoom-in" @click="openWin('../../static/typeImg.html?typeImage=' +form.cardno_url)">查看图片</i>
              <i class="el-icon-delete-solid" @click.stop="delImg(2)">删除图片</i>
              <i class="el-icon-refresh-right" slot="trigger">重新上传</i>
</span>

                    </div>

                  </el-upload>
                </el-form-item>

              </el-col>
          </el-row>

          <el-row :gutter="24">

              <el-col :span="12">
                <el-form-item label="类型" size="small">
                  <el-input v-model="form.type" autocomplete="off"></el-input>
                </el-form-item>
              </el-col>
            <el-col :span="12">
              <el-form-item label="法人身份证" prop="cardno" size="small">
                <el-input v-model="form.cardno" autocomplete="off" ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="社会信用代码" prop="credit_code" size="small">
              <el-input v-model="form.credit_code" autocomplete="off" ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-tooltip :content="form.business_scope" placement="bottom" effect="dark">
              <el-form-item label="经营范围" size="small">
                <el-input v-model="form.business_scope" type="textarea" autocomplete="off"></el-input>
              </el-form-item>
            </el-tooltip>
          </el-col>
        </el-row>
          <el-row :gutter="24">
              <el-col :span="12">
                <el-form-item label="成立日期" prop="" size="small">

                  <el-date-picker v-model="form.incorporation_date" type="date"  placeholder="选择日期"></el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="注册资本" prop="" size="small">
                  <el-input v-model="form.registered_capital" autocomplete="off"></el-input>
                </el-form-item>
              </el-col>
          </el-row>
          <el-row :gutter="24">
              <el-col :span="12">
                <el-form-item label="地址" prop="" size="small">
                  <el-input v-model="form.address" autocomplete="off"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="手机号" prop="" size="small">
                  <el-input v-model="form.mobile" autocomplete="off"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          <el-row :gutter="24">
              <el-col :span="12">
                <el-form-item label="开户行" prop="" size="small">
                  <el-input v-model="form.bank" autocomplete="off"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="账户号码" prop="" size="small">
                  <el-input v-model="form.bank_account" autocomplete="off"></el-input>
                </el-form-item>
              </el-col>
          </el-row>


      </el-form>
        <el-row :gutter="24">
            <el-col :span="12" :offset="12">
                <el-button @click="reset_dialogForm('form')">取 消</el-button>
                <el-button type="primary" @click="submitForm('form')">确 定</el-button>
            </el-col>
        </el-row>

    </el-dialog>
<!--查询E宝信息-->
<el-dialog :title="title" :visible.sync="dialogInfoVisible" width="996px"
           style="overflow: auto;height: auto">
      <el-form :model="einfo" :rules="rules" ref="form" label-width="110px" v-if="orgName">
        <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item label="是否授权身份信息:" size="small" label-width="130px">
              {{einfo.authorizeUserInfo}}
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="实名认证状态:" prop="" size="small" label-width="130px">
              {{einfo.realnameStatus}}
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="机构账号ID:" prop="" size="small" label-width="130px">
              {{einfo.orgId}}
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item label="机构名称:" prop="" size="small" label-width="130px">
              {{einfo.orgName}}
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="机构管理员姓名:" prop="" size="small" label-width="130px">
              {{einfo.orgInfo.adminName}}
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="机构管理员联系方式:" prop="" size="small" label-width="150px">
              {{einfo.orgInfo.adminAccount}}
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div v-else>
        <el-button type="primary" @click="empower()">去授权</el-button>
      </div>
    </el-dialog>
    <!--授权接口-->
    <el-dialog :visible.sync="fileAuth" width="996px"
               style="overflow: auto;height: auto" ref="tk">
      <template>
        <iframe :src="AuthUrl" class="tableClass" width="100%" height="100%"></iframe>
      </template>
    </el-dialog>
    <!-- 全局遮罩 图片上传 -->
    <el-dialog :visible.sync="dialogVisible" :modal="true" :close-on-click-modal="false" :close-on-press-escape="false" width="996px"
               style="overflow: auto;height: auto">
      <div class="loading-overlay">
        <div class="loading-spinner" style="font-size:30px;font-weight: bold">
          <i class="el-icon-upload"></i>
          图片上传ing
          <i class="el-icon-loading"></i>
        </div>
      </div>
    </el-dialog>
    <el-dialog title="公户信息图片" :visible.sync="uploadDialog" class="custom-dialog" width="996px"
               style="overflow: auto;height: auto">



            <el-row :gutter="24">
              <el-col :span="4">
                营业执照 ：
              </el-col>
              <el-col :span="8">
              <span v-if="uploadImg.file_url">
                  <el-image @click="bigImg(`${uploadImg.file_url}`)"
                            style="width: 100px; height: 100px;"
                            :src="`${uploadImg.file_url}`"
                            :preview-src-list="[srcList]"
                            :z-index="99999"
                  ></el-image>

                </span>

                <span v-else>暂无</span>
              </el-col>
              <el-col :span="4">
                法人身份证 :
              </el-col>
              <el-col :span="8">
              <span v-if="uploadImg.cardno_url">
                  <el-image @click="bigImg(`${uploadImg.cardno_url}`)"
                            style="width: 100px; height: 100px;"
                            :src="`${uploadImg.cardno_url}`"
                            :preview-src-list="[srcList]"
                            :z-index="99999"
                  ></el-image>
                </span>

                <span v-else>暂无</span>
              </el-col>
            </el-row>




    </el-dialog>
  </div>
</template>

<script>
import eTable from "../common/eTable.vue";
import moment from 'moment'     //日期时间转换
import {uploadFile} from '../../utils/utils/index'
import axios from 'axios'
export default {
  name: "shopInfoList",
  components: {
    eTable
  },
  props: {},
  data() {
    return {

      srcList:[],
      // 搜索
      searchForm: {
        queryParams: '',
        start_time:'',
        end_time:''
      },
      searchRules: {
        queryParams: [
          { required: true, message: "请输入公司名称", trigger: "blur" },
        ],
      },
      // 数据
      tableLoadData: [],
      limit: 10,
      page:1,// 当前页码
      total:0,//总条目数
      id: '',
      rules: {
        name: [{ required: true, message: '请输入公司名称', trigger: 'blur' }],
        corporation: [{ required: true, message: '请输入法人', trigger: 'blur' }],
        credit_code: [{ required: true, message: '请输入社会信用代码', trigger: 'blur' }],
      },
      dialogFormVisible: false,
      title: '',
      form: {
        name: '',
        address: '',
        credit_code: '',
        composition: '',
        business_scope: '',
        incorporation_date: '',
        corporation: '',
        registered_capital: '',
        certificate_no: '',
        lifespan: '',
        issue_date: '',
        type: '',
        duty_paragraph: '',
        mobile: '',
        bank: '',
        bank_account: '',
        cardno:'',
        cardno_url:'',
        file_url:''
      },    
      uploadImg: '',
      uploadDialog: false,
      dialogInfoVisible: false,
        orgName:true,
        orgNames:'',
        einfo:{
          authorizeUserInfo:'',
          realnameStatus:'',
          orgId:'',
          orgName:'',
          orgInfo:{
            adminName:'',
            adminAccount:''
          },
        },
        fileAuth:false,
        AuthUrl:'',
        dialogVisible: false,
    };
  },
  created() {
    this.DataList()
  },
  mounted() {},
    filters: {
    /**
     * @param {
     *     
     * }
     */
    statusFilter(status) {
      if (status == 1) {
        return "启用";
      } else if (status == 2) {
        return "禁用";
      }
    },
       //时间格式化
    dateFormat(add_time) {
      if (add_time == undefined) {
        return "";
      }
      return moment(add_time*1000).format("yyyy-MM-DD HH:mm:ss");
    },

  },
  methods: {
    getTime (time) {
      if(!time)
      {
        return '';
      }
      var date = new Date(time)
      var y = date.getFullYear()
      var m = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1)
      var d = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate())
      return y + '-' + m + '-' + d
    },
    DataList(){
      const param = {
        company_id:sessionStorage.getItem('company_id'),
        access_token:sessionStorage.getItem('token'),
        page: this.page,
        pageSize:this.limit,
        show_type:2
      }
      if(this.searchForm.queryParams) param.queryParams = this.searchForm.queryParams
      if(this.searchForm.start_time) param.start_time = this.getTime(this.searchForm.start_time)
      if(this.searchForm.end_time) param.end_time = this.getTime(this.searchForm.end_time)
      this.$axios.shopList(param).then(res=>{
        if(res.code == 200){
          this.tableLoadData = res.data.data
          this.total = res.data.total
        }
      }).catch(error=>{
        //console.log(error);
      })
    },
    // 设置每页条数
    handleSizeChange(newSize) {
      this.limit = newSize
      this.DataList()
    },
    // 分页跳转
    handleCurrentChange(newPage) {
      this.page = newPage
      this.DataList()
    },
    // 新增
    addData() {
      this.id = '';
      this.title = '新增'
      this.form = {
        // role_name: '',
      }
      this.dialogFormVisible = true
    },
    handelEdit(index,row) {
      this.id = index.id

      this.title = '编辑'
      this.form = {
      }
      this.dialogFormVisible = true
      // this.form = {...row};
      // 或者
      this.form = JSON.parse(JSON.stringify(index))
    },
    //显示查询企业授权详情页
    checkInfo(index){
        //this.orgNames = index.name;
        this.getOrgAuthInfo(index.name);
        //this.dialogInfoVisible = true;
      },
      //查询企业授权详情
      getOrgAuthInfo(shop_name){
        this.orgNames = shop_name;
        let param = {
          orgName: shop_name,//this.orgName,
          company_id:sessionStorage.getItem('company_id'),
          access_token:sessionStorage.getItem('token')
        }
        this.$axios.getOrgAuthInfo(param).then(res=>{
          if(res.code == 200){
            this.einfo.authorizeUserInfo = res.data.authorizeUserInfo ? '已授权' : '未授权';
            this.einfo.realnameStatus = res.data.realnameStatus ? '已实名' : '未实名';
            this.einfo.orgId = res.data.orgId;
            this.einfo.orgName = res.data.orgName;
            this.einfo.orgInfo.adminName = res.data.orgInfo.adminName;
            this.einfo.orgInfo.adminAccount = res.data.orgInfo.adminAccount;
            
          }else{
            this.orgName = false;
          }
        }).catch(error=>{
          //console.log(error);
        })
        this.dialogInfoVisible = true;
      },
      //企业授权
      empower(){
        this.$refs.tk.$el.firstChild.style.height = '100%';

        let param = {
          orgName: this.orgNames,
          company_id:sessionStorage.getItem('company_id'),
          access_token:sessionStorage.getItem('token')
        }
        this.$axios.setOrgAuthorizehUrl(param).then(res=>{
          if(res.code == 200){
            this.fileAuth = true;
            this.AuthUrl = res.data.authShortUrl;
            //window.open(res.data.shortUrl)
          }
        }).catch(error=>{
          //console.log(error);
        })

      },
    payInfo(index,row){
        this.$router.push({path:'/PayInfoList',query:{id:index.id}});
    },
   
    reset_dialogForm(formName) {
      this.dialogFormVisible = false
      this.id = null
      this.$nextTick(() => {
        this.$refs[formName].resetFields()
      })
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
              const param = {
                cardno:this.form.cardno,
                cardno_url:this.form.cardno_url,
                file_url:this.form.file_url,
                name: this.form.name,
                address: this.form.address,
                credit_code: this.form.credit_code,
                composition: this.form.composition,
                business_scope: this.form.business_scope,
                incorporation_date: this.getTime(this.form.incorporation_date),
                corporation: this.form.corporation,
                registered_capital: this.form.registered_capital,
                certificate_no: this.form.certificate_no,
                lifespan: this.form.lifespan,
                issue_date: this.form.issue_date,
                type: this.form.type,
                duty_paragraph: this.form.duty_paragraph,
                mobile: this.form.mobile,
                bank: this.form.bank,
                bank_account: this.form.bank_account,
                operator_id: sessionStorage.getItem('user_id'),
                company_id:sessionStorage.getItem('company_id'),
                access_token:sessionStorage.getItem('token')
              }
              if(this.form.id) param.id = this.form.id
              // //console.log('param:',param)
              this.$axios.shopShopSave(param).then(res =>{
              if(res.code == 200){
                this.DataList()
                this.$message.success(res.msg)
                this.dialogFormVisible = false
                this.id = null;
              }else{
                  this.$message.error(res.msg);
              }
            })

        }
      })
    },
    searchSubmit() {
      this.page = 1
      this.DataList()
      
    },

    handelDel(e) {
        this.$confirm('此操作将删除该运输公司, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(() => {
        const param = {
          company_id:sessionStorage.getItem('company_id'),
          access_token:sessionStorage.getItem('token'),
          id: e.id,    
        }
        //console.log(param);
        this.$axios.shopShopDel(param).then(res=>{
          if(res.code == 200){
            this.$message.success(res.msg);
            this.DataList()
          }else{
            this.$message.error(res.msg);
          }
        }).catch(error=>{
          //console.log(error);
        })
      }).catch(() => {
          // 点击取消:不删除了
          this.$message({
              type: 'info',
              message: '已取消删除'
          });
          this.DataList()
      });    
      this.teamDialog = false
    },
    // 点击弹出当前的图片
    handelDialog(index) {
      this.uploadDialog = true
      //console.log('handelDialog-index-',index);
      this.uploadImg = index
    },

    //----上传图片--营业执照--
    UploadImage(file) {
      let _this=this;
      _this.dialogVisible = true;
      this.form.file_url = URL.createObjectURL(file.raw);
      //console.log('UploadImage-file',file)
      let payFd = new FormData()
      payFd.append('file', file.raw)
      payFd.append('img_type', 2)
      payFd.append('company_id', sessionStorage.getItem('company_id'))
      payFd.append('access_token', sessionStorage.getItem('token'))
      this.$axios.carUploadImage(payFd).then(res => {
        if (res.code == 200) {
          _this.form.file_url = res.data.src;
          this.$message.success(res.msg)
          _this.dialogVisible = false;
        }else{
          this.$message.error(res.msg)
        }
      }).catch(error => console.log('UploadImage-error',error))

    },
    //----上传图片--法人身份证--
    UploadImage2(file) {
      let _this=this;
      _this.dialogVisible = true;
      this.form.cardno_url = URL.createObjectURL(file.raw);
      //console.log('UploadImage2-file',file)
      let payFd = new FormData()
      payFd.append('file', file.raw)
      payFd.append('img_type', 3)
      payFd.append('company_id', sessionStorage.getItem('company_id'))
      payFd.append('access_token', sessionStorage.getItem('token'))
      this.$axios.carUploadImage(payFd).then(res => {
        if (res.code == 200) {
          _this.form.cardno_url = res.data.src;
          this.$message.success(res.msg)
          _this.dialogVisible = false;
        }else{
          this.$message.error(res.msg)
        }
      }).catch(error => console.log('UploadImage-error',error))

    },
    openWin(url) {
      var name;                           //网页名称，可为空;
      var iWidth = 500;                         //弹出窗口的宽度;
      var iHeight = 570;                        //弹出窗口的高度;
      //window.screen.height获得屏幕的高，window.screen.width获得屏幕的宽
      var iTop = (window.screen.height - 30 - iHeight) / 2;       //获得窗口的垂直位置;
      var iLeft = (window.screen.width - 10 - iWidth) / 2;        //获得窗口的水平位置;
      window.open(url, name, 'height=' + iHeight + ',innerHeight=' + iHeight + ',width=' + iWidth + ',innerWidth=' + iWidth + ',top=' + iTop + ',left=' + iLeft + ',toolbar=no,menubar=no,scrollbars=auto,resizable=no,location=no,status=no');
    },
    delImg(type){
      if(type==1){
        this.form.file_url = '';
      }else if(type==2){
        this.form.cardno_url = '';
      }
    },
    bigImg(url) {
      this.srcList = url;
      //console.log('srcList----',this.srcList)
    },

  },
};
</script>
<style>
  .table_name{
      font-weight: bold;
      /* border: 1px solid #f00; */
  }
  .table_name:hover{
      color: #409EFF;
      cursor: pointer;
  }
  .fontStyle1{
    display: block;
    font-size:14px;
    color: #606266;
  }
  .fontStyle2,.fontStyle3{
    font-size:14px;
    color: #3a8ee6;
  }
  .fontStyle3{
    font-size:22px;
    color: #999;
    position: absolute;
    bottom: 1px;
    right: 1px;
  }
  .custom-dialog {
    height: auto !important;
  }


  .el-dialog, .el-dialog__body {
      height: auto !important;
  }
</style>



// WEBPACK FOOTER //
// src/view/shipCompany/shopInfoList.vue